module.exports = __webpack_public_path__ + "img/top-2.b84e3a2c.png";